import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { CommandService } from '../../shared/services/command.service';
import { DeviceInputBaseComponent } from '../device-input-base.component';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import {
    CommandOptimizationRenderingService
} from '@caslink/device-client/ng-app/shared/services/command-optimization-rendering.service';

// Represents a values that can be enabled or disabled.
@Component({
    selector: 'dl-switch-sensor',
    styleUrls: ['./switch-sensor.component.scss'],
    templateUrl: './switch-sensor.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwitchSensorComponent extends DeviceInputBaseComponent implements OnDestroy {
    public static $name: string = 'switchSensor';

    public formControl: FormControl;

    constructor(
        private commandService: CommandService,
        protected commandOptimizationRenderingService: CommandOptimizationRenderingService,
        protected cdr: ChangeDetectorRef,
    ) {
        super(commandService, commandOptimizationRenderingService, cdr);
    }

    public ngOnInit() {
        super.ngOnInit();
        this.formControl = this.deviceInputForm?.get(this.deviceInput.$fieldName) as FormControl || new FormControl(this.deviceInput.value);
        this.deviceInputForm.addControl(this.deviceInput.$fieldName, this.formControl);
    }

    ngOnDestroy() {
        super.ngOnDestroy();
        this.deviceInputForm.removeControl(this.deviceInput.$fieldName);
    }

    public invokeCommand(checked: boolean) {
        this.deviceInput.value = checked;

        this.invokeChangeCommand(this.deviceInput);
    }

    onUpdate(matSlideToggleChange: MatSlideToggleChange) {
        this.invokeCommand(matSlideToggleChange.checked);
        this.markControlAsTouched();
    }

    onButtonToggleUpdate(matSlideToggleChange: MatButtonToggleChange) {
        this.invokeCommand(matSlideToggleChange.value);
        this.markControlAsTouched();
    }

    private markControlAsTouched() {
        this.formControl.markAsDirty();
        this.formControl.markAsTouched();
    }
}